module.exports = __webpack_public_path__ + "public/images/generated-learn-to-draw-people.71b66405e0f82d57862c7076f28fc515.jpg";